"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ABTESTS = void 0;
var ABTESTS = {
  DESKTOP: {
    mutualInbox: 'coreweb.desktop.mutualInbox',
    removeWVM: 'coreweb.desktop.removeWVM',
    stirRemoveSearch: 'coreweb.stir.removeSearch'
  },
  MOBILEWEB: {}
};
exports.ABTESTS = ABTESTS;
var _default = ABTESTS;
exports.default = _default;